import { drawerAnatomy as parts } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const helpers = createMultiStyleConfigHelpers(parts.keys)

const baseStyle = helpers.definePartsStyle({
  header: {
    fontFamily: 'heading',
    fontSize: 'xl',
    fontWeight: 'light',
    borderBottom: '1px solid',
    borderBottomColor: 'gray.200',
  },
  footer: {
    borderTop: '1px solid',
    borderTopColor: 'gray.200',
  },
  body: {
    py: 8,
  },
  closeButton: {
    borderRadius: 'sm',
    top: 2,
    right: 2,
  },
})

export default helpers.defineMultiStyleConfig({
  baseStyle,
  defaultProps: {
    size: 'md',
  },
})
